var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.699219 15.6234H3.81922V6.26344H0.699219V15.6234ZM17.8592 7.04344C17.8592 6.18544 17.1572 5.48344 16.2992 5.48344H11.3774L12.1184 1.91884L12.1418 1.66924C12.1418 1.34944 12.0092 1.05304 11.7986 0.842438L10.9718 0.0234375L5.83942 5.16364C5.55082 5.44444 5.37922 5.83444 5.37922 6.26344V14.0634C5.37922 14.9214 6.08122 15.6234 6.93922 15.6234H13.9592C14.6066 15.6234 15.1604 15.2334 15.3944 14.6718L17.75 9.17284C17.8202 8.99344 17.8592 8.80624 17.8592 8.60344V7.04344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.1a45fc3e612eccb5d674f22e9514d3d0.svg";
export { ForwardRef as ReactComponent };